<template>
    <ion-card-content class="pr-0">
        <div v-if="initialItem && availableTopping">
            <saladToppings
                v-if="initialItem.isSalad"
                :initialItem="initialItem"
                :availableTopping="availableTopping"
                :parentToppingCount="toppingCount"
                :selectedSize="selectedSize"
                v-model:dressing="localDressing"
                v-model:toppings="localToppings"
                @blockSubmit="$emit('blockSubmit', $event)"
                @limits="qtylimit"
            />
            <!-- Used for Wings & Appetizers -->
            <wingToppings
                v-else-if="initialItem.isWing || initialItem.isAppetizer"
                :initialItem="initialItem"
                :availableTopping="availableTopping"
                :parentToppingCount="toppingCount"
                :selectedSize="selectedSize"
                v-model:flavor="localFlavor"
                v-model:dressing="localDressing"
                @blockSubmit="$emit('blockSubmit', $event)"
            />
            <pizzaToppings
                v-else-if="!initialItem.isMisc && availableTopping.toppings.length > 0"
                :initialItem="initialItem"
                :availableTopping="availableTopping"
                :parentToppingCount="toppingCount"
                :selectedSize="selectedSize"
                :selectedRecipe="selectedRecipe"
                :sauceCups="sauceCups"
                v-model:toppings="localToppings"
                v-model:defaultToppings="localDefaultToppings"
                v-model:twoSidedItem="localTwoSidedItem"
                v-model:dressing="localDressing"
                @blockSubmit="$emit('blockSubmit', $event)"
            />
        </div>
        <div v-else>
            <dynamicSkeleText element="div" :childElements="[{ width: 60, height: '24px', class: 'mx-a mb-8' }]" />
            <dynamicSkeleText v-for="i in Array.from({ length: 4 }, (_, i) => i + 1)" :key="i" element="div" :childElements="skeleText" />
        </div>
    </ion-card-content>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IonCardContent } from '@ionic/vue';
import saladToppings from '@/components/menu/toppings/saladToppings.vue';
import wingToppings from '@/components/menu/toppings/wingToppings.vue';
import pizzaToppings from '@/components/menu/toppings/pizzaToppings.vue';
import baseToppings, { passThroughBindings } from '@/components/menu/toppings/baseToppings.vue';
import dynamicSkeleText from '@/components/dynamicSkeleText.vue';
import { skeleText } from '@/models/props/skeleText';

export default defineComponent({
    extends: baseToppings,
    components: { saladToppings, wingToppings, pizzaToppings, IonCardContent, dynamicSkeleText },
    emits: ['limit', 'blockSubmit'],
    setup(props, { emit }) {
        const { localFlavor, localDressing, localToppings, localDefaultToppings, localTwoSidedItem } = passThroughBindings(props, emit);
        const skeleText: skeleText[] = [
            { width: 5, height: '24px', display: 'inline-block', marginRight: '5px' },
            { width: 30, height: '24px', display: 'inline-block', marginRight: '5px' },
            { width: 20, height: '24px', display: 'inline-block', marginRight: '5px', background: 'transparent' },
            { width: 35, height: '24px', display: 'inline-block', marginRight: '5px' },
        ];

        const qtylimit = (e) => {
            emit('limit', e);
        };

        return { localFlavor, localDressing, localToppings, localDefaultToppings, localTwoSidedItem, skeleText, qtylimit };
    },
});
</script>
